import MenuIconMobile from './MenuIconMobile';

export default MenuIconMobile;
